/**
 * CricketXtreme — Production-Safe Logger
 * ============================================================================
 * In development (local dev server): all logs are printed.
 * In production: only warnings and errors are printed.
 * Sensitive data (UIDs, tokens) is never logged in production.
 *
 * Usage:
 *   import logger from '../utils/logger';
 *   logger.info('MyComponent', 'Some message');     // Dev only
 *   logger.success('MyComponent', 'Done!');          // Dev only
 *   logger.highlight('MyComponent', 'Key data:', d); // Dev only
 *   logger.warn('MyComponent', 'Something off');     // Always
 *   logger.error('MyComponent', 'Failed:', err);     // Always
 * ============================================================================
 */

const isDev = process.env.NODE_ENV !== 'production';

const logger = {
  /** Styled debug log — dev only. Verbose diagnostic output. */
  debug: (tag, ...args) => {
    if (isDev) console.log(`%c[${tag}]`, 'color: #9e9e9e; font-weight: bold', ...args);
  },

  /** Styled info log — dev only. Routine flow messages. */
  info: (tag, ...args) => {
    if (isDev) console.log(`%c[${tag}]`, 'color: #00bcd4; font-weight: bold', ...args);
  },

  /** Styled success log — dev only. Happy-path confirmations. */
  success: (tag, ...args) => {
    if (isDev) console.log(`%c[${tag}]`, 'color: #4caf50; font-weight: bold', ...args);
  },

  /** Styled highlight log — dev only. Important data dumps. */
  highlight: (tag, ...args) => {
    if (isDev) console.log(`%c[${tag}]`, 'color: #e20d73; font-weight: bold', ...args);
  },

  /** Sync verification log — dev only. Real-time data monitoring. */
  sync: (tag, ...args) => {
    if (isDev) console.log(`%c[Sync Verify] ${tag}`, 'color: #00ffff; font-weight: bold', ...args);
  },

  /** Warning log — always printed. Recoverable issues. */
  warn: (tag, ...args) => {
    console.warn(`[${tag}]`, ...args);
  },

  /** Error log — always printed. */
  error: (tag, ...args) => {
    console.error(`[${tag}]`, ...args);
  },
};

export default logger;
